import { cn } from "@u/cn";
import { type VariantProps } from "class-variance-authority";
import { panelVariants } from "./panel-variants";

interface PanelProps
  extends React.ComponentProps<"div">,
    VariantProps<typeof panelVariants> {}

/**
 * Canonical surface/card shell. Replaces the ad-hoc
 * `rounded-2xl border border-border/50 bg-card/50 p-6` pattern (~20+ copies).
 */
export function Panel({
  surface,
  radius,
  pad,
  hover,
  className,
  ...props
}: PanelProps) {
  return (
    <div
      className={cn(panelVariants({ surface, radius, pad, hover }), className)}
      {...props}
    />
  );
}
